import { Close } from "@mui/icons-material";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Typography,
} from "@mui/material";

type headerStatsType = {
  open: boolean;
  onClose: () => void;
  job: any;
};

const HeadersStats = ({ open, onClose, job }: headerStatsType) => {

  return job === null ? null : (
    <Dialog open={open} fullWidth onClose={onClose} fullScreen>
      <DialogTitle>
        <Typography fontWeight={"bold"} color={"primary"}>
          Header Stats
        </Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <Typography>{job.id}</Typography>
      </DialogContent>
    </Dialog>
  );
};

export default HeadersStats;
